<!------------------------------------------------------------------------------
  Copyright (c) 2018. Keni Williams <kenneth.williams@estuk.co.uk>

  This file HeaderOverlay.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  HeaderOverlay.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<!------------------------------------------------------------------------------
 File: HeaderOverlay.vue 
 Created by Keni Williams <kenneth.williams@estuk.co.uk>.
 with: IntelliJ IDEA
 Date: 2018-12-21
 Time: 10:08
------------------------------------------------------------------------------->
<template>
    <header v-on:click="$emit('headerClick')"
            class="card-header card-header-overlay"
    :class="header_class">
        <slot name="content"></slot>
    </header>
</template>

<script>
	export default {
		name: "header-overlay",
		components: {},
		props: {
			header_class:{
				default:'clearfix text-center'
            }
        },
		created() {
		},
		destroyed() {
		},
		mounted() {

		},
		data() {
			return {}
		},
		methods: {},
		watch: {},
		computed: {}
	}
</script>



// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/headers/HeaderOverlay.vue